//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ViewBox, Group, Cell, CellBox, Actionsheet } from 'vux'
import { WHeader } from '@/components/wx'

export default {
  name: 'setting',
  data () {
    return {
      showActionsheet: false,
      actionsheetMenus: [
        {
          label: '退出当前账号？<br/><span style="color:#666;font-size:12px;">退出之后需要重新登录</span>',
          type: 'info'
        },
        {
          label: '退出',
          type: 'warn',
          value: 'logout'
        }
      ]
    }
  },
  methods: {
    logout () {
      console.log('退出')
    }
  },
  components: {
    ViewBox,
    WHeader,
    Group,
    Cell,
    CellBox,
    Actionsheet
  }
}
